module.exports = __webpack_public_path__ + "static/Bitmap_4.9f26d4bb.png";